<template>
  <Section class="pb-4">
    <template #header class="align-center">
      <div class="mr-auto">
        <strong>Membership</strong>
      </div>
      <div class="red--text font-weight-bold">EXPIRED</div>
    </template>

    <div class="mx-n3">
      <v-divider />
    </div>

    <div class="px-2 mt-3">
        Your membership has expired. You must have an active membership
        <strong>to receive new leads</strong> from your partners.
    </div>  
    <div class="px-2 mt-3">
        You can try running your card again, or enter a new payment method
        to reactivate your membership.
    </div>

    <div class="d-flex justify-center mt-3">
      <v-btn color="primary" :to="{ name: 'reactivate' }">Reactivate</v-btn>
    </div>  
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import { mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'MembershipSection',

  components: { Section },

  computed: {
    ...mapGetters('auth', ['me']),

    renewal_message() {
      if (this.me.membership_last_valid_time) {
        return {
          message: 'Your membership is valid through:',
          date: this.formatDate(this.me.membership_last_valid_time),
        }
      }

      return {
        message: 'Your membership is currently complementatory',
        date: '',
      }
    }
  },

  methods: {
    ...formatters,
  },
}
</script>
